export default {
	namespaced: true,
	state: {
		account: null,
		total: {
			loans: 0,
			shares: 0,
			savings: 0,
			deposits: 0,
		},
		loans: [],
		shares: [],
		savings: [],
		deposits: [],

		loanApplications: [],

		notifications: [],
	},

	mutations:{
		/**
		 * [set_notifications description]
		 * @param {[type]} state         [description]
		 * @param {[type]} notifications [description]
		 */
		set_notifications(state, notifications) {
			state.notifications= notifications
		},

		/**
		 * [setLoanApplications description]
		 * @param {[type]} state [description]
		 */
		setLoanApplications(state, applications) {
			state.loanApplications=applications
		},

		/**
		 * [setLoans description]
		 * @param {[type]} state [description]
		 * @param {[type]} loans [description]
		 */
		setLoans(state, loans) {
			state.loans=loans
		},

		/**
		 * [setDeposits description]
		 * @param {[type]} state    [description]
		 * @param {[type]} deposits [description]
		 */
		setDeposits(state, deposits) {
			state.deposits= deposits
		},
		
		/**
		 * [setTotal description]
		 * @param {[type]} state   [description]
		 * @param {[type]} payload [description]
		 */
		setTotal(state, payload) {
			state.total=payload
		},

		/**
		 * [setAccount description]
		 * @param {[type]} state   [description]
		 * @param {[type]} account [description]
		 */
		setAccount(state, account) {
			state.account=account
		}
	},
	getters:{
		/**
		 * [notifications description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		notifications(state) {
			return state.notifications
		},

		/**
		 * [loanApplications description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		loanApplications(state) {
			return state.loanApplications
		},

		/**
		 * [loans description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		loans(state) {
			return state.loans
		},

		/**
		 * [deposits description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		deposits(state) {
			return state.deposits
		},

		/**
		 * [account description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		account(state) {
			return state.account
		},

		/**
		 * [total description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		total(state) {
			return state.total
		}
	},
	actions: {
		/**
		 * [get_notifications description]
		 * @param  {[type]} options.commit      [description]
		 * @param  {[type]} options.getters     [description]
		 * @param  {[type]} options.rootState   [description]
		 * @param  {[type]} options.rootGetters [description]
		 * @param  {[type]} payload             [description]
		 * @return {[type]}                     [description]
		 */
		get_notifications({commit, getters, rootState, rootGetters}, payload) {
			// console.log(rootGetters)
			// console.log(rootGetters['auth/account'])
			return this._vm.$http.get('member/notifications').then(response => {
				commit('set_notifications', response.data)
				return response.data
			})
		},

		/**
		 * [get_applied_loan_information description]
		 * @param  {[type]} options.commit         [description]
		 * @param  {[type]} options.getters        [description]
		 * @param  {[type]} options.account_id     [description]
		 * @param  {[type]} options.application_id [description]
		 * @return {[type]}                        [description]
		 */
		get_applied_loan_information({commit, getters, rootGetters}, application_id) {
			return this._vm.$http.get('loan-applications/member/applied/information', {params: {application_id}})
				.then(response => {
					return response.data
				})
		},

		/**
		 * [get_loan_calculations description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} account_id      [description]
		 * @return {[type]}                 [description]
		 */
		get_loan_calculations({commit, getters}, account_id) {
			// return this._vm.$http.get('loan-applications/member/calculations/account/'+account_id)
			return this._vm.$http.get('loan-applications/member/calculations')
				.then(response => {
					return response.data
				})
		},

		/**
		 * [get_applied_loans description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} account_id      [description]
		 * @return {[type]}                 [description]
		 */
		get_applied_loans({commit, getters}, account_id) {
			// return this._vm.$http.get('loan-applications/member/applied/'+account_id)
			return this._vm.$http.get('loan-applications/member/applied')
				.then(response => {
					return response.data
				})
		},

		/**
		 * [postApplication description]
		 * @param  {[type]} options.commit       [description]
		 * @param  {[type]} options.getters      [description]
		 * @param  {[type]} options.loan_id      [description]
		 * @param  {[type]} options.requirements [description]
		 * @return {[type]}                      [description]
		 */
		post_application({commit, getters}, {calculate_id, form}) {
			const formData = new FormData()

			if(form.benificiary) {
				formData.append('benificiary[fullname]', form.benificiary.fullname)
				formData.append('benificiary[birthDate]', form.benificiary.birthDate)
				formData.append('benificiary[relationship]', form.benificiary.relationship)
				
				formData.append('maritalStatus[gender]', form.maritalStatus.gender)
				formData.append('maritalStatus[civilStatus]', form.maritalStatus.civilStatus)
			}
			formData.append('disbursementType', form.disbursementType)
			formData.append('selfiePhoto', form.selfiePhoto)
			formData.append('eSignature', form.eSignature)
			form.requirements.forEach((req, key) => {
				// console.log(key)
				formData.append('requirements['+key+'][id]', req.id)
				if(req.file) {
					formData.append('requirements['+key+'][file]', req.file.file)
				}
			})
			return this._vm.$http.post('loan-applications/member/submit-application/'+calculate_id, formData)
				.then(response => {
					return response.data
				})
		},

		/**
		 * [getLoanApplications description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} payload         [description]
		 * @return {[type]}                 [description]
		 */
		getLoanApplications({commit, getters}, payload) {
			if(getters['loanApplications'].length) {
				return Promise.resolve(getters['loanApplications'])
			}

			return this._vm.$http.get('products-and-services/member/loan-applications')
				.then(response => {
					commit('setLoanApplications', response.data)
					return response.data
				})
		},

		/**
		 * [getLoans description]
		 * @return {[type]} [description]
		 */
		getLoans({commit, getters, state}, payload) {
			if(getters['loans'].length||!getters['account']) {
				return Promise.resolve(getters['loans'])
			}

			return this._vm.$http.get('microbanker/members/loans-history-payments/'+getters['account'].id)
				.then(response => {
					commit('setLoans', response.data)
					return response.data
				})
		},

		/**
		 * [getDepositHistory description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} options.state   [description]
		 * @param  {[type]} history         [description]
		 * @return {[type]}                 [description]
		 */
		getDepositHistory({commit, getters, state}, history) {
			return this._vm.$http.post('microbanker/members/deposits-history/records/'+getters['account'].id, history)
				.then(response => {
					// commit('setDeposits', response.data)
					return response.data
				})
		},

		/**
		 * [getDepositHistory description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} options.state   [description]
		 * @param  {[type]} payload         [description]
		 * @return {[type]}                 [description]
		 */
		getDepositHistory({commit, getters, state}, record) {
			return this._vm.$http.post('microbanker/members/deposits/history/'+getters['account'].id, record)
				.then(response => {
					// commit('setDeposits', response.data)
					return response.data
				})
		},

		/**
		 * [getDepositHistory description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} payload         [description]
		 * @return {[type]}                 [description]
		 */
		getDeposits({commit, getters, state}, payload) {
			if(getters['deposits'].length) {
				return Promise.resolve(getters['deposits'])
			}

			return this._vm.$http.get('microbanker/members/deposits/'+getters['account'].id)
				.then(response => {
					commit('setDeposits', response.data)
					return response.data
				})
		},

		/**
		 * [getLoans description]
		 * @param  {[type]} options.commit [description]
		 * @param  {[type]} options.state  [description]
		 * @param  {[type]} account_id     [description]
		 * @return {[type]}                [description]
		 */
		getData({commit, getters}, payload) {
			return this._vm.$http.get('microbanker/members/'+getters['account'].id)
				.then(response => {
					commit('setTotal', response.data)
					return response.data
				})
		}
	},

}